import { Button, Col, Container, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import searchIcon from "../../../assets/images/search_rgb_red.svg";
import checkboxIcon from "../../../assets/images/check_box_rgb_red.svg";
import downloadIcon from "../../../assets/images/download_rgb_red.svg";
import filterIcon from "../../../assets/images/filter_rgb_red.svg";
import "../../../assets/styles/addresses.scss";
import { useFileExport } from "../../../hooks/useFileExport";

const AddressesAllMissingFieldsButtons = ({ onSearch, selectedIds = [], filters = {} }) => {
  const navigate = useNavigate();
  const { exportFile, isExporting } = useFileExport(
    "/Reports/AddressesAllMissingFieldsCsv",
    "addresses-all-missing-fields.csv"
  );

  const handleEditSelected = () => {
    if (selectedIds.length === 0) {
      alert("Proszę wybrać co najmniej jeden rekord do edycji.");
      return;
    }

    const idsParam = selectedIds.join(",");
    navigate(`/information/bulkupdate?ids=${idsParam}`);
  };

  const handleDownloadCsv = async () => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined && v !== null && v !== "") {
            queryParams.append(key, String(v));
          }
        });
      } else if (typeof value === "object") {
        const v = value.value ?? value.label ?? String(value);
        if (v) queryParams.append(key, String(v));
      } else {
        queryParams.append(key, String(value));
      }
    });
    const qs = queryParams.toString();
    if (!qs) {
      alert("Proszę wprowadzić co najmniej jeden filtr przed eksportem do pliku.");
      return;
    }

    const filtersToExport = Object.fromEntries(
      [...queryParams.entries()].map(([k, v]) => [k, v])
    );

    try {
      await exportFile(filtersToExport);
    } catch (e) {
      alert("Wystąpił błąd podczas eksportu CSV.");
    }
  };

  const handleEditWithFilters = () => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined && v !== null && v !== "") {
            queryParams.append(key, String(v));
          }
        });
      } else if (typeof value === "object") {
        const v = value.value ?? value.label ?? String(value);
        if (v) queryParams.append(key, String(v));
      } else {
        queryParams.append(key, String(value));
      }
    });
    navigate(`/information/bulkupdate?${queryParams.toString()}`);
  };

  const renderEditTooltip = (props) => (
    <Tooltip id="edit-tooltip" {...props}>
      Edytuj zaznaczone ({selectedIds.length})
    </Tooltip>
  );

  const renderEditFilterTooltip = (props) => (
    <Tooltip id="edit-filter-tooltip" {...props}>
      Edytuj wszystkie spełniające filtr
    </Tooltip>
  );

  const renderDownloadTooltip = (props) => (
    <Tooltip id="download-tooltip" {...props}>
      Eksportuj dane spełniające kryteria
    </Tooltip>
  );

  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderEditTooltip}
          >
            <Button className="addresses-button" onClick={handleEditSelected}>
              <img
                src={checkboxIcon}
                alt="Edit Selected"
                style={{ width: "75%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderEditFilterTooltip}
          >
            <Button
              className="addresses-button"
              onClick={handleEditWithFilters}
            >
              <img
                src={filterIcon}
                alt="EditFilter"
                style={{ width: "75%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderDownloadTooltip}
          >
            <Button className="addresses-button" onClick={handleDownloadCsv} disabled={isExporting}>
              <img
                src={downloadIcon}
                alt="Download"
                style={{ width: "75%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <Button className="addresses-button" onClick={onSearch}>
            <img
              src={searchIcon}
              alt="Search"
              style={{ width: "75%", height: "75%" }}
            />
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default AddressesAllMissingFieldsButtons;

